import React from 'react';
import Button from 'rmwc/Button';
import Text from '../../components/Text';

export default ({ onClick }) => {
  return (
    <div className="mt-4 text-center">
      <Text use="body1">Want to speak with a Harbor Advisor for free?</Text>
      <div>
        <Button onClick={onClick} theme="secondary" className="text-uppercase mt-2">
          Speak with harbor
        </Button>
      </div>
    </div>
  );
};
